// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__hisgf","title":"Info_title__2K23Z","selects":"Info_selects__1FREr","requiredAsterisk":"Info_requiredAsterisk__3CXsy"};